import { BundleOfferPackageOptionView } from 'selectors/offerPageSelectors'

export const getBundlePropertiesFees = (bundleOffer: App.BundleOffer, packageView: BundleOfferPackageOptionView): App.PropertyFeesDetails[] => {
  const data: App.PropertyFeesDetails[] = []

  for (const option of packageView.options) {
    const offer = bundleOffer.bundledOffers[option.package.offerId]

    if (offer.property && option.propertyFees) {
      data.push({
        propertyName: offer.property.name,
        propertyFees: option.propertyFees ?? 0,
        dueAtPropertyMessage: offer.property.taxesAndFeesContent ? offer.property.taxesAndFeesContent : '',
      })
    }
  }

  return data
}
